import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OutcomesService {

  private outcomeSource = new BehaviorSubject<Outcome>(null);
  currentOutcome = this.outcomeSource.asObservable();

  private outcomeDataSource = new BehaviorSubject<OutcomeFacilityData[]>(null);
  currentOutcomeData = this.outcomeDataSource.asObservable();

  private outcomesSummmarySource = new BehaviorSubject<OutcomeSummary[]>(null);
  outcomesSummaries = this.outcomesSummmarySource.asObservable();

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private http: HttpClient,
    private toastrService: ToastrService,
  ) { }

  getOutcome(outcomeId: number, includeData?: boolean) {
    this.http.get<Outcome>(`${this.baseUrl}api/outcomes/${outcomeId}`).subscribe(
      response => {
        if (!!response) {
          this.outcomeSource.next(response);
          if (!!includeData) {
            this.getOutcomeData(outcomeId);
          }
        }
      },
      error => console.error(error)
    );
  }

  getOutcomeData(outcomeId: number) {
    this.http.get<OutcomeFacilityData[]>(`${this.baseUrl}api/outcomes/${outcomeId}/facility-data`).subscribe(
      response => {
        if (!!response) {
          this.outcomeDataSource.next(response);
        }
      },
      error => console.error(error)
    );
  }

  getOutcomesSummaries() {
    this.http.get<OutcomeSummary[]>(`${this.baseUrl}api/outcomes`).subscribe(
      response => {
        if (response) {
          this.outcomesSummmarySource.next(response);
        }
      },
      error => console.error(error)
    );
  }

  submitWorkflowAction(action: string, outcome: Outcome, outcomeFacilityData: OutcomeFacilityData[]) {
    var apiObj = {
      outcomeId: outcome.outcomeId,
      workflowAction: action,
      reason: outcome.reason,
      appropriatorNotes: outcome.appropriatorNotes,
      dnrNotes: outcome.dnrNotes,
      conclusionNarrative: outcome.conclusionNarrative,
      facilityData: outcomeFacilityData
    }
    this.http.post(`${this.baseUrl}api/outcomes/${outcome.outcomeId}/workflow`, apiObj, { observe: 'response' }).subscribe(response => {
      if (response.status === 200) {
        this.toastrService.success(`Successfully executed the '${action}' workflow for this Outcome!`, 'Success:', {
          positionClass: 'toast-top-full-width',
          closeButton: true,
        });
        this.getOutcome(outcome.outcomeId, true);
      }
    });
  }

}

export interface OutcomeSummary {
  outcomeId: number,
  outcomeStatus: string,
  eventId: number,
  eventStartDate: Date,
  eventEndDate: Date,
  appropriator: string,
  pointOfDiversion: string
}

export interface Outcome {
  outcomeId: number,
  outcomeStatusId: number,
  outcomeStatusName: string,
  eventRequestPackageId: number,
  appropriatorNotes: string,
  dnrNotes: string,
  eventId: number,
  eventStartDate: Date,
  eventEndDate: Date,
  appropriatorId: number,
  appropriatorName: string,
  pointOfDiversionName: string,
  submissionUserName: string,
  submissionTimestamp?: Date,
  reviewUserName: string,
  reviewTimestamp?: Date,
  finalUserName: string,
  finalTimestamp?: Date,
  allowedWorkflowActions: WorkflowAction[],

  conclusionNarrative: string,
  conclusionFileUploadListId: number,

  reason: string
}

export interface OutcomeFacilityData {
  outcomeFacilityDataId: number,
  outcomeId: number,
  projectFacilityAnnualOperatingPlanId: number,
  facilityName: string,
  allocationStartDate: Date,
  allocationEndDate: Date,
  fileUploadListId: number,
  provisionalOtherFiles: string,
  provisionalDescription: string,
  finalOtherFiles: string,
  finalDescription: string,
  outcomeFacilityInstrumentData: OutcomeFacilityInstrumentData[]
}

export interface OutcomeFacilityInstrumentData {
  outcomeFacilityInstrumentDataId: number,
  outcomeFacilityDataId: number,
  projectFacilityInstrumentId: number,
  provisionalTimeseriesTypeId: number,
  provisionalTimeseriesTypeName: string,
  provisionalTimeseriesId: string,
  provisionalOtherFiles: string,
  provisionalDescription: string,
  finalTimeseriesTypeId: number,
  finalTimeseriesTypeName: string,
  finalTimeseriesId: string,
  finalOtherFiles: string,
  finalDescription: string
}


export interface WorkflowAction {
  displayName: string,
  value: OutcomeWorkflowAction
}
export enum OutcomeWorkflowAction {
  SaveDate = "SaveData",
  SubmitData = "SubmitData",
  AcceptData = "AcceptData",
  RejectData = "RejectData",
  SaveReview = "SaveReview",
  SubmitReview = "SubmitReview",
  AcceptReview = "AcceptReview",
  RejectReview = "RejectReview",
  SaveFinal = "SaveFinal",
  SubmitFinal = "SubmitFinal",
  AcceptFinal = "AcceptFinal",
  RejectFinal = "RejectFinal",
  Restart = "Restart"
}
